import { ref } from 'vue';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@vue/apollo-composable';

type ProfileSessionTimeoutConfig = {
    pcSessionTimeout: number;
    mobileSessionTimeout: number;
};

type ProfileSessionTimeoutConfigInput = {
    profileId: string;
    pcSessionTimeout: number;
    mobileSessionTimeout: number;
};

const GET_PROFILE_SESSION_CONFIG_QUERY = gql`
    query getProfileSessionTimeoutConfig($profileId: String!) {
        getProfileSessionTimeoutConfig(profileId: $profileId) {
            pcSessionTimeout
            mobileSessionTimeout
        }
    }
`;

const SAVE_PROFILE_SESSION_CONFIG_MUTATION = gql`
    mutation saveProfileSessionTimeoutConfig($input: ProfileSessionTimeoutConfigInput!) {
        saveProfileSessionTimeoutConfig(input: $input)
    }
`;

const sessionConfig = ref<ProfileSessionTimeoutConfig | undefined>();
const fetchSessionConfigLoading = ref(false);
export function useProfileSessionConfig() {
    const getProfileSessionConfig = (
        sid: string,
        resultCallback?: (T: OriginPermission) => void,
        rejectCallback?: (err: any) => void
    ) => {
        fetchSessionConfigLoading.value = true;
        const { onResult, onError } = useQuery<{
            getProfileSessionTimeoutConfig: ProfileSessionTimeoutConfig;
        }>(
            GET_PROFILE_SESSION_CONFIG_QUERY,
            {
                profileId: sid
            },
            {
                fetchPolicy: 'no-cache'
            }
        );

        onResult(data => {
            // if (data.data?.getProfileSessionTimeoutConfig) { // @fixed 不能加此判断，data.data?.getProfileSessionTimeoutConfig有可能返回null值
            sessionConfig.value = data.data?.getProfileSessionTimeoutConfig;

            // 执行回调
            resultCallback &&
                typeof resultCallback === 'function' &&
                resultCallback(sessionConfig.value);
            fetchSessionConfigLoading.value = false;
            // }
        });

        onError(err => {
            sessionConfig.value = undefined;
            rejectCallback && typeof rejectCallback === 'function' && rejectCallback(err);
            fetchSessionConfigLoading.value = false;
        });
    };
    const {
        mutate: saveProfileSessionConfigMutate,
        loading: saveProfileSessionConfigLoading,
        error: saveProfileSessionConfigError,
        onError: onsaveProfileSessionConfigError
    } = useMutation(SAVE_PROFILE_SESSION_CONFIG_MUTATION, {
        errorPolicy: 'all'
    });

    const saveProfileSessionConfig = (
        param: ProfileSessionTimeoutConfigInput,
        onSuccess?: (res?: any) => void,
        onFailed?: (err?: any) => void
    ) => {
        saveProfileSessionConfigMutate({ input: param }).then(
            result => {
                onSuccess &&
                    typeof onSuccess === 'function' &&
                    onSuccess(result?.data?.saveProfileSessionTimeoutConfig);
            },
            err => {
                onFailed && typeof onFailed === 'function' && onFailed(err);
            }
        );
    };
    return {
        sessionConfig,
        fetchSessionConfigLoading,
        saveProfileSessionConfigLoading,
        getProfileSessionConfig,
        saveProfileSessionConfig
    };
}
